import detailsReducer from './detailsReducer';
export default detailsReducer;